import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';

import Facebook from './Facebook';
import LinkedIn from './LinkedIn';
import Twitter from './Twitter';

import styles from './SocialShare.styles';

interface Props {
  urlToShare: string;
  textToShare?: string;
}

function SocialShare({urlToShare, textToShare}: Props): ReactElement {
  return (
    <div className={cx(styles.socialShare)} data-testid="ui.socialShare">
      <Facebook urlToShare={urlToShare} />
      <Twitter urlToShare={urlToShare} textToShare={textToShare} />
      <LinkedIn urlToShare={urlToShare} />
    </div>
  );
}

export default SocialShare;
